import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './OfferingVisibilityToggle.module.scss'

interface IOfferingVisibilityToggleProps {
  enabled: boolean
  disabled?: boolean
  onClick: (event: React.MouseEvent) => void
}

/** The act on a programme tab: a cross drops the programme from the cockpit, a plus brings a
 *  dropped one back. Each sign says what the click does, so nothing has to be hovered to read it. */
export const OfferingVisibilityToggle = ({
  enabled,
  disabled,
  onClick,
}: IOfferingVisibilityToggleProps) => {
  return (
    <span className={styles.root}>
      <Tooltip
        tipContent={() => (
          <Translation
            span
            text={
              enabled ? 'jbp-program-types-turn-off-offering' : 'jbp-program-types-turn-on-offering'
            }
          />
        )}
      >
        <Button
          className={styles.button}
          variant="text"
          size="sm"
          iconButton={enabled ? 'kbase kbase-close' : 'kbase kbase-add'}
          onClick={onClick}
          disabled={disabled}
        />
      </Tooltip>
    </span>
  )
}
